// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".play{width:45px;top:50%;left:50%;transform:translate(-50%,-50%);z-index:2000}.play--large{width:75px}", ""]);
// Exports
module.exports = exports;
